import { withI18nPlaceholders } from '@change-corgi/core-react/i18n';

import I18N_PLACEHOLDERS from '#config/i18n/placeholders/us-surging-petition-toast/us-surging-petition-toast.yml';

import { UsSurgingPetitionToast as UsSurgingPetitionToastComponent } from './containers/UsSurgingPetitionToast';

export const UsSurgingPetitionToast = withI18nPlaceholders(I18N_PLACEHOLDERS, UsSurgingPetitionToastComponent);
